import type { TalentFilters } from "hooks/use-talents-api";
import { useTalents } from "hooks/use-talents-api";
import type React from "react";
import { useCallback, useState } from "react";
import { TalentListPage } from "routes/crm/TalentListPage/TalentListPage";

const ITEMS_PER_PAGE = 20;

/**
 * タレント一覧ページのコンテナコンポーネント
 * @return {React.ReactElement} タレント一覧ページ
 */
const TalentListPageContainer: React.FC = () => {
  const [filters, setFilters] = useState<TalentFilters>({
    page: 1,
    limit: ITEMS_PER_PAGE,
  });

  const { talents, total, loading, error } = useTalents(filters);

  const handleSearchChange = useCallback((search: string) => {
    setFilters(prev => ({ ...prev, search: search || undefined, page: 1 }));
  }, []);

  const handleAffiliationChange = useCallback((affiliation: string) => {
    setFilters(prev => ({
      ...prev,
      affiliation: affiliation || undefined,
      page: 1,
    }));
  }, []);

  const handleEmploymentTypeChange = useCallback((employmentType: string) => {
    setFilters(prev => ({
      ...prev,
      employmentType: employmentType || undefined,
      page: 1,
    }));
  }, []);

  const handlePageChange = useCallback((page: number) => {
    setFilters(prev => ({ ...prev, page }));
  }, []);

  return (
    <TalentListPage
      talents={talents}
      total={total}
      loading={loading}
      error={error}
      filters={filters}
      onSearchChange={handleSearchChange}
      onAffiliationChange={handleAffiliationChange}
      onEmploymentTypeChange={handleEmploymentTypeChange}
      onPageChange={handlePageChange}
      itemsPerPage={ITEMS_PER_PAGE}
    />
  );
};

export default TalentListPageContainer;
